import { render, staticRenderFns } from "./Func49Novo.vue?vue&type=template&id=bc3cca66&scoped=true"
import script from "./Func49Novo.vue?vue&type=script&lang=js"
export * from "./Func49Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3cca66",
  null
  
)

export default component.exports